






import Vue from 'vue';

export default Vue.extend({
  name: 'ErrorMessage',
  props: {
    successMessage: {
      type: String,
      required: true,
    },
  },
});
